import Vue from 'vue'
import Router from 'vue-router'
const Home = resolve => require(['../views/Home'], resolve)
const Task = resolve => require(['../views/pages/task'], resolve)
const Shop = resolve => require(['../views/pages/shop'],resolve);
const Goodsdetail = resolve => require(['../views/pages/goodsdetail'],resolve);
const Address = resolve => require(['../views/pages/address/addresslist'],resolve);
const AddressEditor = resolve => require(['../views/pages/address/editaddress'],resolve);
const SchoolRank = resolve => require(['../views/pages/ranklist'],resolve);
const Auth = resolve => require(['../views/pages/auth'],resolve);
const Role = resolve => require(['../views/pages/jdauth'],resolve);
const Pay = resolve => require(['../views/pages/pay'],resolve);
const Intro = resolve => require(['../views/pages/intro'],resolve);
const Qzone = resolve => require(['../views/pages/qzone'],resolve);
const Marathon = resolve => require(['../views/pages/marathon'],resolve);
const G100 = resolve => require(['../views/pages/g100'],resolve);

Vue.use(Router)
//LOADING   requiresAuth 0 不需要
export default new Router({
  mode: 'history',
  routes: [
    {
      //!!TODO   PA参数TH 带
      path: '/campusrun',
      name: 'Intro',
      component: Intro,
      meta: {
        title: "2018 CampusRun 全国大学生校园跑步季",
        showloading: true
      }
    }, {
      //!!TODO   PA参数TH 带
      path: '/marathon',
      name: 'marathon',
      component: Marathon,
      meta: {
        title: "2018 CampusRun 全国大学生校园跑步季",
        showloading: true
      }
    },{
      //!!TODO   PA参数TH 带
      path: '/g100',
      name: 'g100',
      component: G100,
      meta: {
        title: "2018 CampusRun 全国大学生校园跑步季",
        showloading: true
      }
    },
    {
      //!!TODO   PA参数TH 带
      path: '/qzonelogin',
      name: 'Qzone',
      component: Qzone,
      meta: {
        title: "2018 CampusRun 全国大学生校园跑步季",
        showloading: true
      }
    },
    {
      //!!TODO   PA参数TH 带
      path: '/index/:urid/:steps/:token',
      // path: '/:urid/:steps/:token',
      name: 'Home',
      component: Home,
      meta: {
        title: "首页",
        showloading: true
      }
    },
    {
      path: '/task/:subid/:state?',
      name: 'Task',
      component: Task,
      meta: {
        title: "任务",
        showloading: true,
        auth:true
      }
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop,
      meta: {
        title: "积分商城",
        showloading: true
      }
    },
    {
      path: '/goods/:goodsid',
      name: 'goodsdetail',
      component: Goodsdetail,
      meta: {
        title: "商品详情",
        showloading: true
      }
    },

    {
      path: '/address',
      name: 'address',
      component: Address,
      meta: {
        title: "收货地址",
        showloading: true
      }
    },
    {
      path: '/address/:addressid/:from',
      name: 'addressedit',
      component: AddressEditor,
      meta: {
        title: "收货地址",
        showloading: true
      }
    },
    {
      path: '/pay/:goodsid',
      name: 'pay',
      component: Pay,
      meta: {
        title: "兑换详情",
        showloading: true
      }
    },
   {
      path: '/schoolrank/:urid/:token/:type',
      name: 'schoolrank',
      component: SchoolRank,
      meta: {
        title: "排行",
        showloading: true
      }
    },
    {
      path: '/jdauth/:type/:jdid?',
      name: 'auth',
      component: Auth,
      // children:[
      //   { path: '', component: Auth },
      // ],
      meta: {
        title: "认证",
        showloading: false
      }
    },
    {
      path: '/role',
      name: 'role',
      component: Role,
      meta: {
        title: "认证",
        showloading: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js